import React, { FormEvent } from "react";
import styles from "./AdHighSchoolCommunity.module.scss";
import Button from "../button/Button";

function AdHighSchoolCommunity() {
  return (
    <div className={styles.bodyContainer}>
      <div className={styles.textBody}>
        <div className={styles.highlight}>Featured Highlights</div>
        <h1 className={styles.title}>Student-Led</h1>
        <h1 className={styles.secondaryTitle}>Initiatives</h1>
        <div className={styles.description}>
          <div>
            <ol>
              <li>Can be completed <strong>outside of class</strong></li>
              <li><strong>Project-based</strong> learning</li>
              <li><strong>Builds leaders</strong> in the school</li>
              <li>Showcase learning to the <strong>school</strong></li>
              <p><strong>& school community</strong> <small>(optional)</small></p>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdHighSchoolCommunity;
